import { Injectable, Injector } from '@angular/core';
import { Overlay, GlobalPositionStrategy } from '@angular/cdk/overlay';
import { DeSnackbarData, DeSnackbarPosition } from './de-snackbar-config';
import { ComponentPortal } from '@angular/cdk/portal';
import { DeSnackbarRef } from './de-snackbar-ref';
// import { DeSnackbarComponent } from '@de-electron/electron-angular-components';
import { DeSnackbarComponent } from './de-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class DeSnackbarService {
  private lastSnackbar: DeSnackbarRef;

  constructor(
    private overlay: Overlay,
    private parentInjector: Injector
  ) {}

  show(data: DeSnackbarData): DeSnackbarRef {
    this.destroyLastSnackbar(this.lastSnackbar);
    const positionStrategy = this.getPositionStrategy(data);
    const overlayRef = this.overlay.create({ positionStrategy });
    data._position = this.getPosition(data);
    const snackbarRef = new DeSnackbarRef(overlayRef);
    this.lastSnackbar = snackbarRef;
    const injector = this.getInjector(data, snackbarRef, this.parentInjector);
    const SnackbarPortal = new ComponentPortal(DeSnackbarComponent, null, injector);
    const snackbarComponentRef = overlayRef.attach(SnackbarPortal);
    snackbarRef.onLinkClick = snackbarComponentRef.instance.linkClick;
    return snackbarRef;
  }

  getPosition(data: DeSnackbarData): DeSnackbarPosition {
    const width = window.innerWidth;
    const mobilePosition = data.mobilePosition || 'bottom';
    const desktopPosition = data.desktopPosition || 'top';
    return width < 768 ? mobilePosition : desktopPosition;
  }

  getPositionStrategy(data: DeSnackbarData): GlobalPositionStrategy {
    const width = window.innerWidth;
    const position = this.overlay.position().global();
    if (width < 768) {
      if (data.mobilePosition === 'top') {
        position.top(`${80 + (data.mobileOffset || 0)}px`);
      } else {
        position.bottom(`${80 + (data.mobileOffset || 0)}px`);
      }
    } else {
      if (data.desktopPosition === 'bottom') {
        position.bottom(`${80 + (data.desktopOffset || 0)}px`);
      } else {
        position.top(`${80 + (data.desktopOffset || 0)}px`);
      }
    }
    position.centerHorizontally();
    return position;
  }

  destroyLastSnackbar(snackbarRef: DeSnackbarRef) {
    if (snackbarRef) {
      setTimeout(() => {
        snackbarRef.close();
      }, 200);
    }
  }

  getInjector(
    data: DeSnackbarData,
    snackbarRef: DeSnackbarRef,
    parentInjector: Injector
  ): Injector {
    return Injector.create({
      providers: [
        { provide: DeSnackbarData, useValue: data },
        { provide: DeSnackbarRef, useValue: snackbarRef },
      ],
      parent: parentInjector,
    });
  }
}
